import { Skeleton } from '@/components/ui/skeleton';

export default function MeetingPageSkeleton() {
  return (
    <div className={'base-direction-row h-full'}>
      {/* main data container */}
      <div className={'bg-background border-border-primary h-full w-full divide-y overflow-y-auto rounded-2xl border'}>
        {/* page header */}
        <header className={'flex flex-wrap items-center gap-2 p-4'}>
          <Skeleton className="h-10 w-1 rounded-xs" />
          <Skeleton className={'h-6 w-48 rounded-sm'} />
        </header>
        {/* meeting data */}
        <div className="grid w-full grid-cols-[auto_1fr] gap-x-2 gap-y-3 p-4">
          {/* Type row */}
          <div className="flex items-center gap-1">
            <Skeleton className="h-4 w-4 rounded" />
            <Skeleton className="h-4 w-8" />
          </div>
          <Skeleton className="h-5 w-12" />

          {/* Location row */}
          <div className="flex items-center gap-1">
            <Skeleton className="h-4 w-4 rounded" />
            <Skeleton className="h-4 w-16" />
          </div>
          <Skeleton className="h-5 w-20" />

          {/* Date row */}
          <div className="flex items-center gap-1">
            <Skeleton className="h-4 w-4 rounded" />
            <Skeleton className="h-4 w-10" />
          </div>
          <Skeleton className="h-5 w-32" />
        </div>
        {/* meeting description */}
        <div className="space-y-3 p-4">
          <Skeleton className="h-5 w-16" />
          <div className={'w-full space-y-2'}>
            <Skeleton className="h-4 w-full rounded-md" />
            <Skeleton className="h-4 w-3/4 rounded-md" />
            <Skeleton className="h-4 w-5/6 rounded-md" />
          </div>
        </div>
        {/* meeting location or meeting link placeholder */}
        <div className="space-y-3 p-4">
          <Skeleton className="h-5 w-24" />
          <Skeleton className="h-64 w-full rounded-md md:h-96" />
        </div>
      </div>
      {/* meeting attendance or members sidebar */}
      <div className="border-border-primary bg-background w-full rounded-2xl border md:w-xl">
        <div className={'flex h-full w-full grow flex-col divide-y'}>
          <header className={'flex items-center justify-between gap-2 p-4'}>
            <Skeleton className="h-7 w-40" />
            <Skeleton className="h-9 w-9 rounded-md" />
          </header>
          <div className={'space-y-3 p-4'}>
            <Skeleton className="h-13 w-full rounded-md" />
            <Skeleton className="h-13 w-full rounded-md" />
            <Skeleton className="h-13 w-full rounded-md" />
            <Skeleton className="h-13 w-full rounded-md" />
          </div>
        </div>
      </div>
    </div>
  );
}
